module.exports = __webpack_public_path__ + "img/DW365-172.91ef1928.jpg";